import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const serviceCouponOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "服务优惠券名称",
            prop: "couponName",
            type: "input"
        },
        {
            label: "服务类目",
            prop: "joinsWorkServiceCategory",
            solt: true,
            formsolt: true
        },
        {
            label: "服务项目",
            prop: "joinsWorkServiceItem",
            solt: true,
            formsolt: true
        },
        {
            label: "用户类型",
            prop: "clientType",
            solt: true,
            formsolt: true
        }
        ,
        {
            label: "是否长期有效",
            prop: "expiryDate",
            type: "select",
            dicData: DIC.YES_NO,
        },
        {
            label: "有效期",
            prop: "startTime_endTime",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            formatter: function (row, value, label, column) {
                if(row.startTime==null&&row.endTime==null){
                    return "-"
                }
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};